var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-block-list"},[(_vm.title)?_c('h3',{staticClass:"c-block-list__title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),(!!_vm.$slots.actions)?_c('div',{staticClass:"c-block-list__actions"},[_vm._t("actions")],2):_vm._e(),_c('div',{staticClass:"c-block-list__items",class:{
      'c-block-list__items--shadow': _vm.shadow,
      'c-block-list__items--no-padding': !_vm.padding
    }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }